import React, { Component } from "react";
import regbanner from "../../../assets/icons/regBanner.jpeg";
import "./EsignMainPage.scss";
import EsignNewForm from "./EsignNewForm";
import useQuery from "../../../customHooks/useQuery";
import { AGetClientDetailsByPan } from "../../Services/registration/panDobApiService";
export interface IQueryObject {
  Pan?: string;
  UserId?: string;
}
const EsignMainPage = () => {
  const queryParams = useQuery();
  const id = queryParams.get("id") ? queryParams.get("id") : "";
  const [pan, setPan] = React.useState<string>("");
  const [userId, setUserId] = React.useState<string>("");
  const [isKRA, setIsKRA] = React.useState<boolean>(false);
  React.useEffect(() => {
    if (id !== null && id !== undefined && id !== "") {
      const panObj = JSON.parse(atob(id)) as IQueryObject;
      if (
        panObj !== null &&
        panObj !== undefined &&
        !!panObj?.Pan &&
        panObj?.Pan !== ""
      ) {
        setPan(panObj.Pan);
        if (!!panObj?.UserId && panObj?.UserId !== "")
          setUserId(panObj?.UserId);
      }
    }
  }, []);
  return (
    <div className="esign-new-main">
      <div className="checkStatusHeading">
        <label>{isKRA ? "Authenticate & Submit" : "E-sign"}</label>
      </div>
      <div className="banner">
        <img className="bannerImg" src={regbanner} alt="banner" />
      </div>
      <EsignNewForm
        pan={pan}
        setIsKRA={setIsKRA}
        isKRA={isKRA}
        userId={userId}
      />
    </div>
  );
};

export default EsignMainPage;
